<script>

import ScholarshipSideDialog from "../ScholarshipSideDialog.vue";
import {mapMutations, mapState} from "vuex";
import _ from "lodash";
import TheEditAchievementTypeStatementDialog from "./TheEditAchievementTypeStatementDialog.vue";
import TheStatementCardAllComment from "../../Cards/Meeting/TheStatementCardAllComment.vue";
import ScholarshipMeetingApi from "../../Services/Api/MeetingApi/ScholarshipMeetingApi";
import ThePastStatementExpansionPanelContent from "../../Cards/Meeting/ThePastStatementExpansionPanelContent.vue";
import TheMeetingRecordBookStudent from "./Information/TheMeetingRecordBookStudent.vue";

const TheMeetingStatementInformationDialog = () => import("./Information/TheMeetingStatementInformationDialog.vue");

const TheMeetingShowAchievementDialog = () => import("./TheMeetingShowAchievementDialog.vue");

const TheStudentScholarshipScoreCard = () => import("../../Cards/Student/TheStudentScholarshipScoreCard.vue");

const TheMeetingScholarshipAchievementsStatementTable = () =>
  import("../../Tables/Meeting/TheMeetingScholarshipAchievementsStatementTable.vue");

const TheMeetingVoteCommentAchTypeCard = () => import("../../Cards/Meeting/TheMeetingVoteCommentAchTypeCard.vue");

const TheMeetingEditAchievementParametersDialog = () =>
  import("./TheMeetingEditAchievementParametersDialog.vue");

const TheMeetingStatementAchievementTypeCard = () =>
  import("../../Cards/Meeting/TheMeetingStatementAchievementTypeCard.vue");

const ThePastStatementCard = () => import("../../Cards/Meeting/ThePastStatementCard.vue");

export default {
  name: "TheMeetingShowStatementDialog",

  props: {
    loadingStatement: Boolean,
  },

  components: {
    TheMeetingRecordBookStudent,
    ThePastStatementExpansionPanelContent,
    TheStatementCardAllComment,
    TheStudentScholarshipScoreCard,
    TheMeetingScholarshipAchievementsStatementTable,
    ScholarshipSideDialog,
    TheEditAchievementTypeStatementDialog,
    TheMeetingVoteCommentAchTypeCard,
    TheMeetingEditAchievementParametersDialog,
    TheMeetingStatementInformationDialog,
    TheMeetingStatementAchievementTypeCard,
    TheMeetingShowAchievementDialog,
    ThePastStatementCard,

  },

  watch: {
    statement: function () {
      this.show = !_.isEmpty(this.statement);
      this.tab = 0;
    },

    'statement.achievements': function (newAchievements, oldAchievements) {
      if (_.isEmpty(this.demonstratedAchievement) && this.showAchievementsDialog) return;
      const achievement = _.find(newAchievements, (achievement) => achievement.id === this.demonstratedAchievement.id);

      if(_.isNil(achievement)) {
        this.showAchievementsDialog = false;
        this.demonstratedAchievement = {};
      } else {
        this.demonstratedAchievement = achievement;
      }
    },
  },

  data() {
    return {
      defaultScore: {
        "sum_score_education": 0.0,
        "sum_score_research": 0.0,
        "sum_score_social_activity": 0.0,
        "sum_score_cultural_creative": 0.0,
        "sum_score_sports": 0.0,
        "sum_score": 0.0,
      },

      show: false,

      showAchievementsDialog: false,

      showAchievementTypeDialog: false,

      menu: false,

      showEditAchievementDialog: false,

      selectedEditAchievement: {},

      showInformationDialog: false,

      loadingZip: false,

      classCols: 'py-0 my-0',

      demonstratedAchievement: {},

      tab: 0,

      dialogRecordBookStudent: false,
    };
  },

  computed: {

    ...mapState({
      statement: state => state.scholarship_competition.statement,
      meeting: state => state.scholarship_meeting.meeting,
    }),


    statementScores() {
      const scores = this.statement?.person_scores;
      if (_.isNil(scores)) return this.defaultScore;
      return scores[0];
    },

    statementAchievements() {
      return this.statement?.achievements || [];
    },

    fullNameStudentWithStatement() {
      return this.statement?.person?.full_name || "Нет ФИО";
    },


  },

  methods: {
    ...mapMutations({
      setStatement: "scholarship_competition/setStatement",
    }),

    resetStatement() {
      this.setStatement({});
    },

    openEditAchievement(achievement) {
      this.selectedEditAchievement = achievement;
      this.showEditAchievementDialog = true;
    },

    closeEditAchievement() {
      this.selectedEditAchievement = {};
      this.showEditAchievementDialog = false;
    },

    showAchievementDialog(achievement) {
      this.demonstratedAchievement = achievement;
      this.showAchievementsDialog = true;
    },

    closeAchievementDialog() {
      this.demonstratedAchievement = {};
      this.showAchievementsDialog = false;
    },

    showRecordBookStudent(achievement) {
      this.dialogRecordBookStudent = true
    },

    closeRecordBookStudent() {
      this.dialogRecordBookStudent = false
    },

    async downloadZipFile() {
      this.loadingZip = true;

      try {
        const response = await ScholarshipMeetingApi.backupFilesCompetitionForId(this.meeting.id, this.statement.id);

        const href = window.URL.createObjectURL(response.data);

        const anchorElement = document.createElement('a');

        anchorElement.href = href;
        anchorElement.download = `${this.fullNameStudentWithStatement}.zip`;

        document.body.appendChild(anchorElement);
        anchorElement.click();

        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);
      } catch (err) {
        console.log(err)
      }

      this.loadingZip = false;
    },

  },

}
</script>

<template>
  <div>
    <scholarship-side-dialog
      :visible="show"
      @close="resetStatement"
      width="1200px"
      position-dialog="right"
    >
      <v-card-title>
        <span>Заявление от {{fullNameStudentWithStatement}}</span>
        <div class="mx-2"/>
        <v-btn @click="showRecordBookStudent" small color="teal darken-3" class="rounded-xl white--text" v-html="'Зачетная кн-ка'"/>
        <v-spacer/>

        <v-btn
          icon
          @click="downloadZipFile"
          :loading="loadingZip"
        >
          <v-icon>fa-download</v-icon>
        </v-btn>

        <v-btn
          icon
          @click="showInformationDialog = true"
        >
          <v-icon>fa-question-circle</v-icon>
        </v-btn>

        <v-btn
          icon
          @click="resetStatement"
        >
          <v-icon>
            fa-times
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-row :style="{'max-width': '100%', 'margin': '12px 0 0 0'}">
        <v-col
          cols="6"
          :class="[classCols]"
        >
          <v-sheet>
            <the-meeting-statement-achievement-type-card
              :statement="statement"
              @showAchievementTypeDialog="showAchievementTypeDialog = true"
            />
            <template v-if="tab === 0">
              <div class="my-3"></div>
              <the-student-scholarship-score-card
                :person-scores="statementScores"
                :isPersonScoresPresent="true"
              />
            </template>
            <div class="my-3"></div>
            <v-tabs
              v-model="tab"
              color="teal darken-3"
              grow
            >
              <v-tab
                key="comments"
              >
                Все комментарии
              </v-tab>
              <v-tab
                key="past-statements"
              >
                Прошлые заявления
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                key="comments"
              >
                <the-statement-card-all-comment
                  :achievements="statementAchievements"
                  :statement="statement"
                  @open-achievement="showAchievementDialog"
                />
              </v-tab-item>
              <v-tab-item
                key="past-statements"
              >
                <the-past-statement-card @openAchievement="showAchievementDialog" />
              </v-tab-item>
            </v-tabs-items>
          </v-sheet>


        </v-col>
        <v-col
          cols="6"
          :class="[classCols]"
        >
          <v-sheet
            outlined
            rounded="xl"
          >
            <the-meeting-scholarship-achievements-statement-table
              :achievements="statementAchievements"
              @openEditAchievement="openEditAchievement"
              @openAchievement="showAchievementDialog"
            />
          </v-sheet>
        </v-col>
      </v-row>

    </scholarship-side-dialog>

    <the-meeting-show-achievement-dialog
      :achievement="demonstratedAchievement"
      :visible="showAchievementsDialog"
      @close="closeAchievementDialog"
      @openEditAchievement="openEditAchievement"
    />

    <the-edit-achievement-type-statement-dialog
      :visible="showAchievementTypeDialog"
      @close="showAchievementTypeDialog = false"
    />

    <the-meeting-edit-achievement-parameters-dialog
      :achievement="selectedEditAchievement"
      :visible="showEditAchievementDialog"
      @close="closeEditAchievement"
    />

    <the-meeting-statement-information-dialog
      :visible="showInformationDialog"
      @close="showInformationDialog = false"
    />

    <the-meeting-record-book-student
      :visible="dialogRecordBookStudent"
      @close="closeRecordBookStudent"
    />

  </div>
</template>

<style scoped>
</style>